import React from 'react';

import {
  Flex,
  HStack,
  Stack,
  Text,
} from '@chakra-ui/react';
import dayjs from 'dayjs';

import { FULL_DATETIME_FORMAT } from 'utils/dates';

import DriverInfo from './DriversInfo';

import { IconRow, InfoRow } from '../Texts';

interface AirportInfoProps {
  data: any
}

export default function AirportInfo({ data = {} }: AirportInfoProps) {
  return (
    <Flex
      mb={8}
      mx={1}>
      <Flex
        width="60%"
        flexDir="column">
        <Text
          variant="smallBold"
          color="gray.600">
          {data.code}
        </Text>
        <InfoRow
          label="Operadora:"
          value={data.operator}
        />
        <InfoRow
          label="Remetente:"
          value={data.sourceName}
        />
        <InfoRow
          label="Destinatário:"
          value={data.destinationName}
        />
        <InfoRow
          label="Consignatário:"
          valueColor="primary.default"
          value={data.consignee}
        />
        <Flex flexDir="column">
          <Text
            variant="xSmallSemiBold"
            mt={6}
            color="gray.500">
            Origem:
          </Text>
          <Text
            variant="smallBold"
            color="gray.600">
            {data.dispatchSource?.name}
          </Text>
          <Text
            variant="smallBold"
            color="gray.600">
            {dayjs(data.boardingAt).format(FULL_DATETIME_FORMAT)}
          </Text>
        </Flex>
      </Flex>
      <Flex
        justifyContent="space-between"
        flexDir="column">
        <Stack flexDir="column">
          <IconRow
            label="plane"
            value="Convencional"
            direction="row"
          />
          <IconRow
            label="clock"
            value="Frequencia"
            direction="row"
          />
          <HStack
            alignItems="flex-start"
            spacing={4}>
            <DriverInfo
              initialKm={data.initialKm}
              finalKm={data.finalKm}
              drivers={data.drivers}
              vehicle={data.vehicle}
            />
            <DriverInfo
              initialKm={data.followupInitialKm}
              finalKm={data.followupFinalKm}
              drivers={data.destinationDrivers}
              vehicle={data.destinationVehicle}
            />
          </HStack>
        </Stack>
        <Flex flexDir="column">
          <Text
            variant="xSmallSemiBold"
            mt={6}
            color="gray.500">
            Destino:
          </Text>
          <Text
            variant="smallBold"
            color="gray.600">
            {data.dispatchDestination?.name}
          </Text>
          <Text
            variant="smallBold"
            color="gray.600">
            {dayjs(data.collectAt).format(FULL_DATETIME_FORMAT)}
          </Text>
        </Flex>
      </Flex>
    </Flex>
  );
}
